import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from 'prop-types';
import React from 'react';
import { deepExtract } from 'helpers/deep';
import * as ObjectUtil from 'helpers/object';
export var Toggle = function Toggle() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return React.createElement("label", {
    className: "media"
  }, React.createElement("input", _extends({}, ObjectUtil.omit(['value'], props.input), {
    checked: deepExtract('input.value', props) ? 'checked' : '',
    className: "media__img",
    type: "checkbox"
  })), React.createElement("span", {
    className: "media__body"
  }, props.label));
};
Toggle.propTypes = {
  input: PropTypes.object,
  label: PropTypes.node
};